<div class="mrd" *ngIf="detail as d">
  <!-- <div class="mrd__handle" aria-hidden="true"></div> -->

  <header class="mrd__header">
    <h1 class="mrd__title">Meal Request Details</h1>
    <button type="button" class="mrd__close-btn" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="mrd__body">
    <section class="mrd-card" aria-label="Campus and request summary">
      <div class="mrd-card__bg" aria-hidden="true"></div>
      <div class="mrd-card__inner">
        <div class="mrd-card__avatar" [attr.aria-hidden]="profileImageObjectUrl ? null : 'true'">
          <img
            *ngIf="profileImageObjectUrl"
            class="mrd-card__avatar-img"
            [src]="profileImageObjectUrl"
            [alt]="userName || 'Profile'"
          />
          <mat-icon *ngIf="!profileImageObjectUrl" class="mrd-card__avatar-icon">person</mat-icon>
        </div>
        <div class="mrd-card__text">
          <div class="mrd-card__name">{{ userName }}</div>
          <div class="mrd-card__id" *ngIf="userId">{{ userId }}</div>
          <div class="mrd-card__addr">{{ d.campusName }}</div>
          <div class="mrd-card__mobile" *ngIf="d.requestedMobileNo">{{ d.requestedMobileNo }}</div>
          <div class="mrd-card__total">
            Total Heads:
            <span class="mrd-card__total-num">{{ formatNum(totalHeads(d.headcounts)) }}</span>
          </div>
        </div>
      </div>
    </section>

    <div class="mrd-table-wrap">
      <table class="mrd-table" *ngIf="d.matrix?.length">
        <thead>
          <tr>
            <th scope="col" class="mrd-table__corner">Heads</th>
            <th scope="col">Breakfast</th>
            <th scope="col">Lunch</th>
            <th scope="col">Snacks</th>
            <th scope="col">Dinner</th>
            <th scope="col">Total</th>
            <th scope="col">Average</th>
          </tr>
        </thead>
        <tbody class="mrd-table__body-highlight">
          <tr *ngFor="let row of d.matrix">
            <th scope="row" class="mrd-table__row-label">{{ row.label }}</th>
            <td>{{ formatNum(row.breakfast) }}</td>
            <td>{{ formatNum(row.lunch) }}</td>
            <td>{{ formatNum(row.snacks) }}</td>
            <td>{{ formatNum(row.dinner) }}</td>
            <td>{{ formatNum(row.heads) }}</td>
            <td class="mrd-table__average">{{ formatAverage(row) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th scope="row" class="mrd-table__row-label mrd-table__total-label">{{ d.matrixTotals.label }}</th>

            <td class="mrd-table__total-cell">{{ formatNum(d.matrixTotals.breakfast) }}</td>
            <td class="mrd-table__total-cell">{{ formatNum(d.matrixTotals.lunch) }}</td>
            <td class="mrd-table__total-cell">{{ formatNum(d.matrixTotals.snacks) }}</td>
            <td class="mrd-table__total-cell">{{ formatNum(d.matrixTotals.dinner) }}</td>
            <td class="mrd-table__total-cell">{{ formatNum(d.matrixTotals.heads) }}</td>
            <td class="mrd-table__total-cell mrd-table__average">{{ formatAverage(d.matrixTotals) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- <button type="button" class="mrd-call" (click)="onCallNow()">
      <mat-icon class="mrd-call__icon">call</mat-icon>
      <span>Call Now</span>
    </button> -->
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>